import { useMutation } from '@tanstack/react-query';
import { generateStory } from '@/services/storytime.service';

export const STORYTIME_GENERATE_MUTATION_KEY = 'storytime-generate';

export const useGenerateStory = () => {
  return useMutation({
    mutationKey: [STORYTIME_GENERATE_MUTATION_KEY],
    mutationFn: generateStory,
  });
};
